import { useProductDummyRoomFormModelContext } from "../context";
import { QuestionDummyRoomBase } from "./base/root";
import { QuestionDummyRoomConnection } from "./connection/root";
import { QuestionDummyRoomPriceAndStockAndPolicy } from "./price-and-stock-and-policy/root";

import type { DummyRoomCategoriesAndManagerStore } from "../store/categories";

type Props = {
	roomCategoriesAndManagerStore: Omit<
		DummyRoomCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const DummyRoomFormMain = ({ roomCategoriesAndManagerStore }: Props) => {
	const { hotelID, roomID } = useProductDummyRoomFormModelContext().viewModel;

	const {
		base, //
		connection,
		priceAndStockAndPolicy,
	} = roomCategoriesAndManagerStore;

	return (
		<>
			<QuestionDummyRoomBase base={base} hotelID={hotelID} roomID={roomID} />
			<QuestionDummyRoomPriceAndStockAndPolicy priceAndStockAndPolicy={priceAndStockAndPolicy} />
			<QuestionDummyRoomConnection connection={connection} />
		</>
	);
};

DummyRoomFormMain.displayName = "DummyRoomFormMain";
